import React from 'react';
import { AppIconContainer } from '../ChipLabel.style';

export const AppSelectLabel = ({ chipDefaultValue, value, disabled }) => {
  if (!value) {
    return chipDefaultValue;
  }

  if (value.renderIcon) {
    return (
      <span>
        <AppIconContainer disabled={disabled}>
          {value.renderIcon({
            size: 'small',
            // to prevent from Mui Icon's title from being shown since we already show tooltip
            IconProps: { titleAccess: null }
          })}
        </AppIconContainer>
        <span>{value.label}</span>
      </span>
    );
  }
};
